const branding = {
  default: {
    logo: "assets/img/logo.png",
    logoWhite: "assets/img/logo-white.png",
    // loginImage: "assets/img/authentication/login02.png",
    loginImage: "assets/img/authentication/pos_sign_in.jpeg",
    smallLogo: "assets/img/logo-small.png",
    appName: "TMIS Admin",
  },
};

export default branding;